import { Tag, TagMap } from '../../../../../../../common/tags/tagTypes';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { selectTags, selectTagPaths } from '../../../../../../element/tags/tagSelectors';
import { getElementsByTagId } from '../../../../../../element/tags/tagsService';
import { TagElementsRetrievalData } from '../../../../../../../common/api/tags/tagElementsRetrievalRouteTypes';

export type UseTagPopupsStateReturn = {
    allTags: Tag[];
    currentlyEditingTag: Tag | null;
    setCurrentlyEditingTagId: (tagId: string | null) => void;
    currentlyEditingTagElements: TagElementsRetrievalData[];
    setCurrentlyEditingTagElements: (tagElements: TagElementsRetrievalData[]) => void;
    retreivingElementsForTag: string | null;
    userRootPath: ImMNElement[];
    shareRootPath: ImMNElement[];
    handleClickEdit: (tag: Tag) => void;
};

const useTagPopupsState = (openModal: () => void): UseTagPopupsStateReturn => {
    const [currentlyEditingTagId, setCurrentlyEditingTagId] = useState<string | null>(null);
    const [currentlyEditingTagElements, setCurrentlyEditingTagElements] = useState<Array<TagElementsRetrievalData>>([]);
    const [retreivingElementsForTag, setRetreivingElementsForTag] = useState<string | null>(null);

    const rootPaths = useSelector(selectTagPaths);
    const { userRootPath, shareRootPath } = rootPaths || {};

    const tags: TagMap | undefined = useSelector(selectTags);
    const currentlyEditingTag = tags?.[currentlyEditingTagId || ''] || null;

    const allTags = Object.values(tags || {});

    const handleClickEdit = async (tag: Tag) => {
        setRetreivingElementsForTag(tag.id);
        const tagElements = await getElementsByTagId(tag.id);

        setCurrentlyEditingTagId(tag.id);
        setCurrentlyEditingTagElements(tagElements);
        setRetreivingElementsForTag(null);
        openModal();
    };

    return {
        allTags,
        currentlyEditingTag,
        setCurrentlyEditingTagId,
        currentlyEditingTagElements,
        setCurrentlyEditingTagElements,
        retreivingElementsForTag,
        userRootPath,
        shareRootPath,
        handleClickEdit,
    };
};

export default useTagPopupsState;
